import { fetch } from './fetch'
import { api } from '@/config'

const { API_APP_URL, USER_INFO_URL } = api

const getUserInfo = params =>
  fetch({ method: 'get', url: `${API_APP_URL}${USER_INFO_URL}`, ...params })

const updateUserInfo = params =>
  fetch({ method: 'patch', url: `${API_APP_URL}${USER_INFO_URL}`, ...params })

export const userAPI = {
  getUserInfo,
  updateUserInfo
}
